
jQuery(document).ready(function($){

	// Call lazy
	loadImages('img.lazy');

	// FORMSTONE SELECT
	$("select").dropdown();

	// IMAGE CAROUSEL
	$('.product-featured').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		fade: true,
		asNavFor: '.product-thumbs'
	});
	$('.product-thumbs').slick({
		slidesToShow: 10,
		slidesToScroll: 1,
		asNavFor: '.product-featured',
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 8,
				}
			},
		]
	});

	// TOGGLES
	//---------------------------
	$('#menu-toggle a').click( function(){
		switch($(this).attr('class')){
			case 'open-nav':
				$(this).attr('class','close-nav');
				$('body').addClass('menu-open');
				$('#filter-toggle span.cover').addClass('fade');
				resizeNav();
				if($('#page').height() <= $('#nav').height()){
					$('#page').height($('#nav').height());
				}
				$('#news-info-bar').hide();
				break;
			case 'close-nav':
				$(this).attr('class','open-nav');
				$('body').removeClass('menu-open');
				$('#filter-toggle span.cover').removeClass('fade');
				$('#nav').height('auto');
				$('#page').height('auto');
				setTimeout( function(){ $('#news-info-bar').fadeIn();}, 300 );
				break;
		}
		return false;
	});

	$('#overlay').click( function(){
		$('#menu-toggle a').attr('class','open-nav');
		$('body').removeClass('menu-open');
		$('#filter-toggle span.cover').removeClass('fade');
		$('#nav').height('auto');
		$('#page').height('auto');
	});

	$('#filter-toggle a').click( function(){

		switch($(this).attr('class')){
			case 'open-filter':
				$(this).attr('class','close-filter');
				$('body').addClass('filter-open');
				$('#menu-toggle span').addClass('fade');
				resizeNav();
				break;
			case 'close-filter':
				$(this).attr('class','open-filter');
				$('body').removeClass('filter-open');
				$('#menu-toggle span').removeClass('fade');
				$('#filter').height('auto');
				$('#page').height('auto');
				break;
		}

		return false;
	});


	$('#nav').css('min-height',$('#nav').height()+'px');
	$('#filter').css('min-height',$('#filter').height()+'px');

	// Resize nav to page height
	function resizeNav(){

		$('#page, #nav, #filter').height('auto');

		winH = $(window).height();
		pageH = $('#page').height();
		filterH = $('#filter').height();
		navH = $('#nav').height();

		if(navH < pageH){ $('#nav').height(pageH); }
		if(filterH < pageH){ $('#filter').height(pageH); }
		if(navH < winH){ $('#nav').height(winH); }
		if(filterH < winH){ $('#filter').height(winH); }
		if(navH < pageH){ $('#nav').height(pageH); }
		if(filterH < pageH){ $('#filter').height(pageH); }
		if(pageH < winH){ $('#page, #nav, #filter').height(winH); }

	}

	resizeNav();
	$(window).resize(function() {
		resizeNav();
	})




	// Portfolio and Images pages
	if($('#floating-filter-toggle').length > 0){

		// Add floating toggle once scrolled passed toggles
		$(window).scroll(function(){
			var top = $(this).scrollTop();
			if(top > 135){
				$('body').addClass('floating-toggle');
			}else{
				$('body').removeClass('floating-toggle');
			}
		});
		$('#floating-filter-toggle').click( function(){
			$("html, body").animate({ scrollTop: 0 }, {duration: 1200, easing: 'easeOutQuad'});
			$('#filter-toggle a').click();
		})
	}



	var allTags = new Array();

	$('.product').each( function(){
		tags = $(this).attr('rel').split(" ");
		for (var i=0; i<tags.length; i++){
			if(tags[i] != ''){
				if(allTags.indexOf(tags[i]) == -1 && tags[i] != ' ' && tags[i] !== 'require-terms'){
					allTags.push(tags[i]);
				}
			}
		}
	})

	for (var i=0; i<allTags.length; i++){
		$('#media-listing ul').append('<li><a class="'+allTags[i]+'" href="/collections/'+allTags[i].toLowerCase()+'">'+allTags[i].replace(/-/g,' ')+'</a></li>');
	}

	project = new Array();
	media = new Array();
	classes = new Array();


	$('#projects-listing a, #media-listing a').click( function(event){
		event.preventDefault();
		var path = $(this).attr('href');
		$('#projects-listing a, #media-listing a').removeClass('active');
		$(this).addClass('active');
		$('#page-content').addClass('fade');
		$('body').addClass('loading');
		$('#loading').css('top',$(this).offset().top+9+'px').css('left',$(this).offset().left-13+'px');

		// Load artwork
		$.ajax({
			type: 'GET',
			url: path,
			success: function(html) {
				$('#page-content').removeClass('fade');
				$('body').removeClass('loading');
				$(this).addClass('active');
				$('.view.thumbs').html($(html).find('.view.thumbs > div'));
				loadImages('img.lazy');
				resizeNav();
			}
		});

		resizeNav();

	});


	$('#product .add-to-cart').click(function(e){
		$('#add-item-to-cart').click();
	});

	$('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
		$(this).blur();
	})




}); // end document ready

// LAZY LOAD IMAGES
//---------------------------
function loadImages(selector){
	jQuery(selector).lazy({
		bind: 'event',
		effect: 'fadeIn',
		combined: true,
		delay: 100,
		effectTime: 1000,
		enableThrottle: true,
		throttle: 250,
		afterLoad: function(element) {
			jQuery(element).removeClass('lazy');
		},
		beforeLoad: function(element) {
			// Lazy will call this function, before the image gets loaded
			//console.log('Loading' + element.attr('data-src'));
		},
		onLoad: function(element) {
			// while loading the image, especially on big images, this function will be called
		},
		onError: function(element) {
			// if the image could not get loaded successfully, this is the triggered function
			//console.log("error loading image: " + element.attr("data-src"));
		}
	});
}
